<template>
  <path
    d="M17.7001 19.7002C18.0901 19.3102 18.0901 18.6802 17.7001 18.2902L15.0001 15.5902L13.5901 17.0002L16.2901 19.7002C16.6801 20.0902 17.3201 20.0902 17.7001 19.7002ZM8.71006 8.00021H11.0001V13.5902L6.29006 18.2902C5.90006 18.6802 5.90006 19.3102 6.29006 19.7002C6.68006 20.0902 7.31006 20.0902 7.70006 19.7002L13.0001 14.4002V8.00021H15.2901C15.7401 8.00021 15.9601 7.46021 15.6401 7.15021L12.3501 3.86021C12.1501 3.66021 11.8401 3.66021 11.6401 3.86021L8.35006 7.15021C8.04006 7.46021 8.26006 8.00021 8.71006 8.00021Z"
  />
</template>
